import { AuthState } from 'old/atoms/auth';
import { type ReactNode, useCallback } from 'react';

/**
 * @deprecated This is temporal hack for upgrade React Router v5 to v6
 * Do not use this, find better solution
 */
const SplitAuthenticationGuard = ({
  authenticated,
  notAuthenticated,
}: {
  authenticated: ReactNode;
  notAuthenticated: ReactNode;
}) => {
  const render = useCallback(
    (isAllowed: boolean): ReactNode => {
      if (isAllowed) {
        return authenticated;
      }

      return notAuthenticated;
    },
    [authenticated, notAuthenticated],
  );

  return <AuthState permissions={[{ scope: 'authenticated' }]} render={render} />;
};

export default SplitAuthenticationGuard;
